module.exports = __webpack_public_path__ + "img/promo_box_1_bg.062a9704.jpg";